import React from "react";
import {Typography } from '@mui/material';

const Contact = () => {
  return (
        <section id="contactus">
    <div style={{ display: "flex", justifyContent: "space-between" ,  maxWidth: '900px', margin: '0 auto' , backgroundColor: 'lightblue'}}>
      <div style={{ width: "50%", padding: "20px" }}>
        <h2>Contact our friendly team</h2>
        <p>Visit us:</p>
        <p>Foodsakz, Head Office <br />
          Chennai<br />
          Tamil Nadu 600050</p>
        <p>Contact us:</p>
  <Typography variant="body2">
        <p>WhatsApp : +91 999 464 1128</p>
        <p>Email: <a href="mailto:info@foodsakz.com">info@foodsakz.com</a> </p>
            </Typography>
      </div>

      <div style={{ width: "50%" }}>
 <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d920.7151776983669!2d80.18823304497971!3d13.092231124334718!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1755020532954!5m2!1sen!2sus" 
width="600"
height="450"
allowfullscreen=""
loading="lazy"
referrerpolicy="no-referrer-when-downgrade">
  </iframe>
    </div>

    </div>
      </section>
  );
};

export default Contact;
